import { render, staticRenderFns } from "./StudyCard.vue?vue&type=template&id=3582e478&"
import script from "./StudyCard.vue?vue&type=script&lang=js&"
export * from "./StudyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports